import { Store } from "pullstate";

export const AppStore = new Store({
  network: null,
  onboardingModal: false,
  onboardingStep: 0,
});